export default [
  {
    path: '/purchase',
    name: 'package',
    component: () => import('../viewH5/purchase/Index.vue'),

    children: [
      {
        path: 'package-list',
        name: 'packageList',
        component: () => import('../viewH5/purchase/PackageList.vue'),
      },
      {
        path: 'order-list',
        name: 'orderList',
        component: () => import('../viewH5/purchase/OrderList.vue'),
      },
    ],
  },
]
